import AgencyServiceList from './AgencyServiceList';

export default AgencyServiceList;



// WEBPACK FOOTER //
// ./src/ondemand/components/AgencyServiceList/index.js